/**
 * The `EventName` enumeration contains the names of all the available events in the Jan platform.
 */
export enum InferenceEvent {
  /** The `OnInferenceStopped` event is emitted when a inference is stopped. */
  OnInferenceStopped = 'OnInferenceStopped',
}
